<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">{{ isEditMode ? 'Edit Article' : 'Add Article' }}</div>
  </section>

  <form [formGroup]="userArticleForm" (ngSubmit)="onSubmit($event)">
    <section class="modal-content-container">
      <div>
        <label for="articleUrlId" class="input-title required">Article URL</label>
        <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userArticleForm, 'link')">
          <input id="articleUrlId" formControlName="link" type="text" placeholder="Article URL" />
        </div>
      </div>

      <div class="mt-16">
        <label for="articleTitleId" class="input-title required">Article title</label>
        <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userArticleForm, 'title')">
          <input id="articleTitleId" formControlName="title" type="text" placeholder="Article title" />
        </div>
      </div>
    </section>

    <div *ngIf="summaryErrorMessage" class="flex justify-center items-center my-20 text-sienna">
      {{ summaryErrorMessage }}
    </div>
    <section class="modal-actions-container">
      <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button type="submit" alt="Add Article" class="btn btn-lg">
        {{ isEditMode ? 'Save Changes' : 'Add Article' }}
      </button>
    </section>
  </form>
</div>
